import { getUserCulture } from 'owa-session-store';
import WeatherTemperatureUnit from 'owa-service/lib/contract/WeatherTemperatureUnit';

/**
 * Gets the fallbck temperature unit based off of user's culture.
 * If English(US) is used, return Fahrenheit, otherwise return Cesius
 */
export default function getFallbackWeatherUnit(): WeatherTemperatureUnit {
    return getUserCulture() === 'en-US'
        ? WeatherTemperatureUnit.Fahrenheit
        : WeatherTemperatureUnit.Celsius;
}
